/** 方便开发到已部署的环境调试 */
export const isChartTestMode = window.location.search.includes('chart-test=1');
